export class DialogModelGSTResponse{
    constructor(
      public message: any
    ) {}
  }